var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surface"},[_c('EditableLine',{attrs:{"color":[0, 1, 0, 1]},model:{value:(_vm.profile.line),callback:function ($$v) {_vm.$set(_vm.profile, "line", $$v)},expression:"profile.line"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }